import React, {memo, useState} from 'react'

import {
  hearAboutTypes, maxLength
} from '../../../helpers/data-constants'
import {
  HInput,
  HSelect,
  HTextarea,
  passParamsThrough
} from '../../../validation/HForm'
import CharCount from '../CharCount/CharCount';

const ClientInfoOtherAdd = memo((props) => {
  const { watch, clientActive, hidden, hearAboutDefault, aimAndRelationshipFeatures } = props;
  const [state, setState] = useState({
    hearAbout: hearAboutDefault,
    hidden: hidden
  });

  const handleChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.id;

    setState({
      [name]: value
    });
  }

  return (
    passParamsThrough(
      <div>
      {hidden && (
        <>
        {!clientActive && <div className="form-element">
            <label className="form-element-label"
                   htmlFor="hearSource">Основание для запрета обслуживания</label>
            <div className="form-element-data">
              <HInput h className="input" type="text"
                      name="client.rejectionReason"
                      id="hearSource"/>
            </div>
          </div>}

        <div className="form-element">
          <label className="form-element-label" htmlFor="contactsType">Откуда узнали о нас</label>
          <div className="form-element-data">
            <HSelect h 
              defaultValue={state.hearAbout}
              onChange={handleChange}
              className="input" type="text"
              name="client.hearAbout"
              id="hearAbout"
              options={["", ...hearAboutTypes]}/>
          </div>
        </div>
        {
          state.hearAbout === "Другое" &&
          <div className="form-element">
            <label className="form-element-label"
                   htmlFor="hearSource">Источник</label>
            <div className="form-element-data">
              <HInput h className="input" type="text"
                      name="client.hearSource"
                      id="hearSource"/>
            </div>
          </div>
        }
        {aimAndRelationshipFeatures && <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Цели установления и характер отношений с
                ООО «ВИСЕМ»</label>
              <div className="form-element-data">
                <HSelect h className="input" type="text"
                         name="client.aimAndRelationship"
                         id="aimAndRelationship"
                         options={['', 'Получение микрозайма']}
                         defaultValue={['Получение микрозайма']}
                />
              </div>
            </div>
          </div>
        </div>}
        </>
      )}
        {!hidden && <div className="form-element">
          <label className="form-element-label"
                 htmlFor="clientAdditionalDescription">
            Дополнительное описание
          </label>
          <div className="form-element-data textarea">
            <HTextarea h="true" className="input" rows="15" cols="10"
                       name="client.otherInformation"
                       id="description"/>
          </div>
          <CharCount value={watch('client.description')} maxLength={maxLength.ADDITIONAL} />
        </div>}
      </div>, props)
  )
})

export default ClientInfoOtherAdd
